import React from 'react';
import OnboardingDashboardCard from './OnboardingDashboardCard';

function MultiplemacIdCard(props) {
    const {  multiStateMACId } = props;

    let content = <div className="row no-gutters card-row margin-8-0 text-center">
        <div className="col min-height-40">
            <div className={"onboarding-table margin-0-20"}>
                <table className={"width-100p margin-bottom-0"}>

                    <thead>
                    <tr className="alerts-table-row">
                        <th className="table-shrink">
                            MAC ID
                        </th>
                        <th className="table-shrink">
                            Customers
                        </th>
                        <th className="table-shrink">
                            Count
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    {multiStateMACId !== undefined && multiStateMACId !== null && multiStateMACId.length && multiStateMACId.map((macIds, index) =>
                        <tr key={macIds.macId} data={index} className="alerts-table-row">
                            <td> {macIds.macId} </td>
                            <td> {macIds.customer} </td>
                            <td> {macIds.totalCount} </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    </div>;

    return (
        <div>
            <OnboardingDashboardCard title={"Duplicate MAC Ids"} content={content} isGraphCard={false} />
        </div>
    );
}

export default MultiplemacIdCard;